import { TFunction } from 'i18next';
import { InputDropdownOptions } from '../../../shared/LCFormFieldInputDropdown';
import { AgeCategory } from '../../../../../../models/AgeCategory';

export const mapAgeCategory = (ageCategory: string | undefined, t: TFunction): InputDropdownOptions<string> => {
    return {
        current: ageCategory,
        all: [
            { key: AgeCategory.ADULT, value: t('ageCategory.Adult') },
            { key: AgeCategory.YOUNG_ADULT, value: t('ageCategory.Young Adult') },
            { key: AgeCategory.CHILDREN, value: t('ageCategory.Children') }
        ]
    };
};
